import { gql } from '@apollo/client';

const MARK_NOTIFICATION_ASREAD = gql`
mutation markUserNotificationAsRead($userNotificationId: Int!) {
  userNotificationContext {
    markAsRead(userNotificationId: $userNotificationId)
  }
}`;

export default MARK_NOTIFICATION_ASREAD;
